import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

// *load ข้อมูลโรงงาน สำหรับ create
function* quickTestLoadLocation(action) {
  const {
    data: {
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-dest-location-list`,
      {
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.quickTestLoadLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadLocation.failure())
  }
}

function* quickTestLoadSourceLocationForCreate(action) {
  const {
    data: {
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-origin-location-list-for-source-quick-test`,
      {
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.quickTestLoadSourceLocationForCreate.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadSourceLocationForCreate.failure())
  }
}

// *load ข้อมูลต้นแหล่ง สำหรับค้นหา
function* quickTestLoadSourceLocation(action) {
  const {
    data: {
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-origin-location-list-for-source-quick-test`,
      {
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    yield put(actions.quickTestLoadSourceLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadSourceLocation.failure())
  }
}

// *load ข้อมูลต้นแหล่งทราย
function* quickTestLoadOriginLocationSand(action) {
  const {
    data: {
      dest_location_id,
      material_type,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,

      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-origin-location-list`,
      {
        dest_location_id,
        material_type,
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestLoadOriginLocationSand.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadOriginLocationSand.failure())
  }
}

// *load ข้อมูลต้นแหล่งหิน
function* quickTestLoadOriginLocationRock(action) {
  const {
    data: {
      dest_location_id,
      material_type,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,

      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-origin-location-list`,
      {
        dest_location_id,
        material_type,
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestLoadOriginLocationRock.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadOriginLocationRock.failure())
  }
}

// *load ข้อมูล preview
function* quickTestPreview(action) {
  const {
    data: {
      rock_grade,
      rock_percent,
      sand_grade,
      sand_percent,
      dest_location_id,
      tested_date,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/preview-quick-test`,
      {
        rock_grade,
        rock_percent,
        sand_grade,
        sand_percent,
        dest_location_id,
        tested_date,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestPreview.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestPreview.failure())
  }
}

// *ดึงข้อมูล quick test by id
function* quickTestGetById(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-quick-test-by-id`,
      {
        id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestGetById.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestGetById.failure())
  }
}

// *ดึงรายการ Quick Test
function* quickTestGetList(action) {
  const {
    data: {
      order_by,
      order_type,
      page,
      page_size,
      type,
      limit_export,
      file_value_pdf,
      filter_obj,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-quick-test-list`,
      {
        order_by,
        order_type,
        page,
        page_size,
        type,
        limit_export,
        file_value_pdf,
        filter_obj,
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestGetList.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestGetList.failure())
  }
}

// *create ข้อมูล Quick Test
function* quickTestCreate(action) {
  const {
    data: { data, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/create-quick-test`,
      {
        ...data,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestCreate.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestCreate.failure())
  }
}

// *update ข้อมูล Quick Test
function* quickTestUpdate(action) {
  const {
    data: { data, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/update-quick-test`,
      {
        ...data,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestUpdate.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestUpdate.failure())
  }
}

// *delete ข้อมูล Quick Test
function* quickTestDelete(action) {
  const {
    data: { id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/delete-quick-test`,
      {
        id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestDelete.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestDelete.failure())
  }
}

// *export ข้อมูล Quick Test
function* quickTestExportExcel(action) {
  const {
    data: {
      order_by,
      order_type,
      page,
      page_size,
      type,
      limit_export,
      file_value_pdf,
      filter_obj,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-quick-test-list`,
      {
        order_by,
        order_type,
        page,
        page_size,
        type,
        limit_export,
        file_value_pdf,
        filter_obj,
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestExportExcel.success(res.data))
    const sftpPath = res.data.data
    const downloadRes = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
      { sftp_path: sftpPath },
      { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
    )
    const ext = sftpPath.split('.').pop().toLowerCase()
    const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const blob = new Blob([downloadRes.data], { type: mimeType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = sftpPath.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestExportExcel.failure())
  }
}

// *import ข้อมูล Quick Test
function* quickTestImportExcel(action) {
  const {
    data: {
      files,
      create_by,
      accessToken,
      typeImport,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,
    },
    loading,
  } = action.payload

  const formData = new FormData()
  let uploadFile = null

  if (files != null) {
    files.forEach((File) => {
      uploadFile = File
    })
  }

  formData.append('files', uploadFile)
  formData.append('typeImport', typeImport)
  formData.append('create_by', create_by)
  formData.append('exactly_location', exactly_location)
  formData.append('is_admin', is_admin)
  formData.append('is_vendor', is_vendor)
  formData.append('location_list', location_list)
  formData.append('company_id', company_id)

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/import-quick-test`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )

    loading(res.data)
    yield put(actions.quickTestImportExcel.success(res.data))
  } catch (err) {
    console.log(err)
    yield put(actions.quickTestImportExcel.failure())
  }
}

// *load ข้อมูลต้นแหล่งหิน for search
function* quickTestLoadOriginLocationRockForSearch(action) {
  const {
    data: {
      dest_location_id,
      material_type,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,

      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-origin-location-list-search`,
      {
        dest_location_id,
        material_type,
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.quickTestLoadOriginLocationRockForSearch.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadOriginLocationRockForSearch.failure())
  }
}

// *load ข้อมูลต้นแหล่งทรายสำหรับ search
function* quickTestLoadOriginLocationSandForSearch(action) {
  const {
    data: {
      dest_location_id,
      material_type,
      company_id,
      exactly_location,
      is_admin,
      is_vendor,
      location_list,

      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quick-test/get-origin-location-list-search`,
      {
        dest_location_id,
        material_type,
        company_id,
        exactly_location,
        is_admin,
        is_vendor,
        location_list,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(
      actions.quickTestLoadOriginLocationSandForSearch.success(res.data)
    )
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadOriginLocationSandForSearch.failure())
  }
}

// *load division
function* quickTestLoadDivision(action) {
  const {
    data: {
      location_visibility,
      division_id,
      department_id,
      section_id,
      plant_id,
      accessToken,
    },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-division`,
      { location_visibility, division_id, department_id, section_id, plant_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestLoadDivision.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadDivision.failure())
  }
}

// *load department
function* quickTestLoadDepartment(action) {
  const {
    data: { location_visibility, division_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-department`,
      { location_visibility, division_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestLoadDepartment.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadDepartment.failure())
  }
}

// *load section
function* quickTestLoadSection(action) {
  const {
    data: { location_visibility, department_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-section`,
      { location_visibility, department_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestLoadSection.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadSection.failure())
  }
}

// *load plant
function* quickTestLoadPlant(action) {
  const {
    data: { location_visibility, section_id, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/isupply-quality-control-lab/load-plant`,
      { location_visibility, section_id },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )

    yield put(actions.quickTestLoadPlant.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.quickTestLoadPlant.failure())
  }
}

export default function* watchQuickTest() {
  yield all([
    takeEvery(actions.QUICK_TEST_LOAD_LOCATION.REQUEST, quickTestLoadLocation),
    takeEvery(
      actions.QUICK_TEST_LOAD_SOURCE_LOCATION.REQUEST,
      quickTestLoadSourceLocation
    ),
    takeEvery(
      actions.QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND.REQUEST,
      quickTestLoadOriginLocationSand
    ),
    takeEvery(
      actions.QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK.REQUEST,
      quickTestLoadOriginLocationRock
    ),
    takeEvery(actions.QUICK_TEST_PREVIEW.REQUEST, quickTestPreview),
    takeEvery(actions.QUICK_TEST_GET_BY_ID.REQUEST, quickTestGetById),
    takeEvery(actions.QUICK_TEST_GET_LIST.REQUEST, quickTestGetList),
    takeEvery(actions.QUICK_TEST_CREATE.REQUEST, quickTestCreate),
    takeEvery(actions.QUICK_TEST_UPDATE.REQUEST, quickTestUpdate),
    takeEvery(actions.QUICK_TEST_DELETE.REQUEST, quickTestDelete),
    takeEvery(actions.QUICK_TEST_EXPORT_EXCEL.REQUEST, quickTestExportExcel),
    takeEvery(actions.QUICK_TEST_IMPORT_EXCEL.REQUEST, quickTestImportExcel),
    takeEvery(
      actions.QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH.REQUEST,
      quickTestLoadOriginLocationRockForSearch
    ),
    takeEvery(
      actions.QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH.REQUEST,
      quickTestLoadOriginLocationSandForSearch
    ),
    takeEvery(
      actions.QUICK_TEST_EVALUATION_LOAD_DIVISION.REQUEST,
      quickTestLoadDivision
    ),
    takeEvery(
      actions.QUICK_TEST_EVALUATION_LOAD_DEPARTMENT.REQUEST,
      quickTestLoadDepartment
    ),
    takeEvery(
      actions.QUICK_TEST_EVALUATION_LOAD_SECTION.REQUEST,
      quickTestLoadSection
    ),
    takeEvery(
      actions.QUICK_TEST_EVALUATION_LOAD_PLANT.REQUEST,
      quickTestLoadPlant
    ),

    takeEvery(
      actions.QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE.REQUEST,
      quickTestLoadSourceLocationForCreate
    ),
  ])
}
export {
  quickTestLoadLocation,
  quickTestLoadSourceLocation,
  quickTestLoadOriginLocationSand,
  quickTestLoadOriginLocationRock,
  quickTestPreview,
  quickTestGetById,
  quickTestGetList,
  quickTestCreate,
  quickTestUpdate,
  quickTestDelete,
  quickTestExportExcel,
  quickTestImportExcel,
  quickTestLoadOriginLocationRockForSearch,
  quickTestLoadOriginLocationSandForSearch,
  quickTestLoadDivision,
  quickTestLoadDepartment,
  quickTestLoadSection,
  quickTestLoadPlant,
  quickTestLoadSourceLocationForCreate,
}
